<div class="grid grid-cols-12 gap-2">
  <mat-form-field appearance="outline" class="col-span-4" floatLabel="always">
    <mat-label>Referring Doctor Name {{ required ? "*" : "" }}</mat-label>
    <input
      matInput
      type="text"
      placeholder="Search referring doctor"
      [disabled]="disabled"
      [(ngModel)]="selectedDoctor"
      (ngModelChange)="filterDoctors($event)"
      [matAutocomplete]="auto"
    />
    <mat-icon matSuffix>search</mat-icon>

    <mat-autocomplete
      panelClass="autocomplete-with-sticky-add"
      #auto="matAutocomplete"
      [displayWith]="displayDoctor"
      (opened)="onPanelOpened()"
      (optionSelected)="onSelectReferringDoctor($event.option.value)"
    >
      <mat-option *ngIf="ability.canCreate(ability.subjects.ReferringDoctors)" (click)="openAddReferringDoctorDialog()" class="sticky-add-option text-blue-500"
        >+ Add new Referring doctor</mat-option
      >
      <mat-option
        *ngFor="let doctor of filteredDoctors"
        [value]="doctor"
      >
        {{ doctor.viewValue }}
      </mat-option>
      <mat-option *ngIf="loading" disabled class="text-gray-500">
        Loading more...
      </mat-option>
      <mat-option *ngIf="ability.canCreate(ability.subjects.ReferringDoctors)" (click)="openAddReferringDoctorDialog()" class="text-blue-500"
        >+ Add new Referring doctor</mat-option
      >
    </mat-autocomplete>
  </mat-form-field>

  <mat-form-field appearance="outline" class="col-span-4 !opacity-60">
    <mat-label>Referring Doctor Phone</mat-label>
    <input
      class="cursor-default"
      matInput
      readonly
      [value]="selectedDoctor?.phone || ''"
    />
  </mat-form-field>

  <mat-form-field appearance="outline" class="col-span-4 !opacity-60">
    <mat-label>Referring Doctor Fax</mat-label>
    <input
      class="cursor-default"
      matInput
      readonly
      [value]="selectedDoctor?.fax || ''"
    />
  </mat-form-field>
</div>
